import { isBefore, parseISO } from 'date-fns';

/**
 * Validate if a date/time combination is stale (i.e., in the past).
 * Typically used for form validation when we have separate date and time inputs
 *
 * @param date - The date string to validate e.g. 2023-01-01.
 * @param hours - The hours string to validate e.g. 14.
 * @param minutes - The minutes string to validate e.g. 30.
 * @returns True if the date is stale, false otherwise.
 */
export const isStaleDate = (date: string, hours: string, minutes: string) => {
	if (!date || !hours || !minutes) return false;
	const now = new Date();
	const parsedDateTime = parseISO(`${date}T${hours}:${minutes}`);
	if (parsedDateTime && isBefore(parsedDateTime, now)) {
		return true;
	}
	return false;
};
